import { call, put, takeLatest } from 'redux-saga/effects';

import { OperatingProcedures } from 'utils/enums';
import { Trip, TripService } from '../../../../entities/Trip';
import { TripSecurityTable } from '../../global/interfaces';
import { getTripsError, getTripsSuccess } from './actions';
import { GET_SECURITY_TRIPS_REQUEST, GET_SECURITY_UNLOADING_TRIPS_REQUEST } from './constants';

function* createEventSaga(isLoadingTrips: boolean) {
  try {
    const trips: Trip[] = yield call(isLoadingTrips ? TripService.getTrips : TripService.getUnloadingTrips);
    const tripsId8 = trips.filter((t) => t.statusId === 8);
    const tripsId1 = trips.filter((t) => t.statusId === 1);
    const tripsId3 = trips.filter((t) => t.statusId === 3);
    const tripsId6 = trips.filter((t) => t.statusId === 6);
    const tripsId2 = trips.filter((t) => t.statusId === 2);
    const tripsId7 = trips.filter((t) => t.statusId === 7);
    const tripsId10 = trips.filter((t) => t.statusId === 10);

    const tripsIdRest = trips.filter(
      (t: any) => t.statusId !== 8 && t.statusId !== 1 && t.statusId !== 6 && t.statusId !== 10,
    );

    tripsIdRest.sort((prev: any, next: any) => prev.statusId - next.statusId);

    const branch = localStorage.getItem('branchId');
    const operatingProcedure = branch ? JSON.parse(branch)?.operatingProcedure : '';

    let tripsFiltered: Trip[] = [];

    if (operatingProcedure === OperatingProcedures.RulesTwo) {
      tripsFiltered = [...tripsId3, ...tripsId6, ...tripsId2, ...tripsId7, ...tripsId10];
    } else if (operatingProcedure === OperatingProcedures.RulesThree) {
      tripsFiltered = [...tripsId3, ...tripsId6, ...tripsId2, ...tripsId7, ...tripsId10];
    } else {
      tripsFiltered = [...tripsId1, ...tripsId6, ...tripsId8, ...tripsId10, ...tripsIdRest];
    }

    const formattedTrips: TripSecurityTable[] = yield call(TripService.formatTripsForSecurityTable, tripsFiltered);

    yield put(getTripsSuccess(formattedTrips));
  } catch (error: any) {
    yield put(getTripsError(error));
  }
}

export function* tripsTabSagaWatcher() {
  yield takeLatest(GET_SECURITY_TRIPS_REQUEST, createEventSaga, true);
}

export function* unloadingTripsTabSagaWatcher() {
  yield takeLatest(GET_SECURITY_UNLOADING_TRIPS_REQUEST, createEventSaga, false);
}
